// extracted by mini-css-extract-plugin
export var content = "_1p-3";
export var contentWrapper = "_1p-2";
export var fullWidthButton = "_1p-4";
export var heroImage = "_1p-6";
export var logo = "_1p-1";
export var logoContainer = "_1p-0";
export var panel = "_1p-5";